<template>
  <section class="about-photo">
    <!-- Wrapper -->
    <figure
      id="about-photo--left"
      class="about-photo__wrapper"
    >
      <picture>
        <source
          media="--small"
          data-srcset="/static/images/about-left-mobile.jpg,
          /static/images/about-left-mobile@2x.jpg 2x, /static/images/about-left-mobile@3x.jpg 3x"
        >

        <source
          media="--large"
          data-srcset="/static/images/about-left.jpg, /static/images/about-left@2x.jpg 2x"
        >

        <img
          class="lazyload"
          data-sizes="auto"
          data-src="/static/images/about-left.jpg"
        >
      </picture>
    </figure>

    <!-- Wrapper -->
    <figure
      id="about-photo--right"
      class="about-photo__wrapper"
    >
      <picture>
        <source
          media="--small"
          data-srcset="/static/images/about-right-mobile.jpg,
          /static/images/about-right-mobile@2x.jpg 2x, /static/images/about-right-mobile@3x.jpg 3x"
        >

        <source
          media="--large"
          data-srcset="/static/images/about-right.jpg, /static/images/about-right@2x.jpg 2x"
        >

        <img
          class="lazyload"
          data-sizes="auto"
          data-src="/static/images/about-right.jpg"
        >
      </picture>
    </figure>

    <!-- Title -->
    <div class="about-photo__title">
      {{ $t('about_5') }}
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutPhoto'
};
</script>

<style lang="scss" src="@/assets/components/about/about-photo-view.scss"></style>



// WEBPACK FOOTER //
// about-photo-view.vue